<div class="loading-bar">
</div>